import { IClientTicketFullTrip } from '@bustickus/models-client';
import * as bi from 'react-bootstrap-icons';
import { Box, Flex, Header } from 'components';
import { useState } from 'react';
import { PointList, SpoilerCard } from 'shared/components';
import { DataRow } from '..';

interface IProps {
  trip: IClientTicketFullTrip;
}

function TripCard(props: IProps) {
  const [open, setOpen] = useState(false);

  return (
    <SpoilerCard
      title='Данные рейса'
      open={open}
      onOpenClick={() => setOpen(!open)}
    >
      <Flex
        gap={10}
        direction='column'
      >
        <Flex
          gap={5}
          direction='column'
        >
          <DataRow
            title={props.trip.carrierName ?? 'Перевозчик неизвестен'}
            icon={<bi.Cursor />}
          />
          {props.trip.number != null && (
            <DataRow
              title='Номер рейса:'
              value={props.trip.number}
              icon={<bi.BusFrontFill />}
            />
          )}
        </Flex>
        <Flex direction='column'>
          {props.trip.documents.passport && (
            <DataRow
              title='Требуется'
              value={'паспорт РФ'}
              icon={<bi.Passport />}
            />
          )}
          {props.trip.documents.foreignPassport && (
            <DataRow
              title='Требуется'
              value={'заграничный паспорт'}
              icon={<bi.Passport />}
            />
          )}
          {props.trip.documents.visaNames.map((visaName) => (
            <DataRow
              key={visaName}
              title='Требуется'
              value={visaName}
              icon={<bi.Passport />}
            />
          ))}
        </Flex>
        <Box
          padding={20}
          variant='darker'
          shadow='inside'
        >
          <PointList points={props.trip.points} />
        </Box>
      </Flex>
    </SpoilerCard>
  );
}

export default TripCard;
